import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
var ErrorDialog = function (_a) {
    var message = _a.message, onClose = _a.onClose;
    return (_jsxs(Dialog, { open: Boolean(message === null || message === void 0 ? void 0 : message.trim()), onClose: onClose, children: [_jsx(DialogTitle, { children: "Error" }), _jsx(DialogContent, { children: _jsx(DialogContentText, { children: message }) }), _jsx(DialogActions, { children: _jsx(Button, { onClick: onClose, autoFocus: true, children: "OK" }) })] }));
};
export default ErrorDialog;
